function initMap() {
  	// MAIN LOCATIONS PAGE - SHOW ALL STORES
  	var all = document.getElementById('mapAll');
  	if (all) {
      	var markersAll = [ 
      		['Australia', -34.6136081,144.7961004],
          	['Narellan', -34.041380, 150.736294],
          	['Bondi', -33.8939381, 151.2597158],
          	['Casula', -33.955525, 150.892019],
          	['Top Ryde', -33.812865, 151.106836],
          	['Figtree', -34.436450, 150.863030],
            ['Rundle Mall', -34.9228396, 138.5997243],
            ['Cronulla',-34.0536761,151.1520854],
            ['Docklands',-37.8145412,144.9411002],
            ['Miranda',-34.0355512,151.1006368],
            ['Parramatta',-33.8179141,150.9995141]
    	]; 
        var mapAll = new google.maps.Map(document.getElementById('mapAll'), {
        	zoom: 6,
          	scrollwheel: true,
          	// centre the map
          	center: {lat: markersAll[0][1], lng: markersAll[0][2]}
    	});
    	// draw up markers
    	for (i=1; i<markersAll.length; i++) {
        	var markerAll = new google.maps.Marker({
            	position: {lat: markersAll[i][1], lng: markersAll[i][2]},
            	map: mapAll,
            	title: markersAll[i][0]
        	});
    	} 
  	}
  
  	// INDIVIDUAL STORES
   	var narellan = document.getElementById('mapNarellan');
  	if (narellan) { 
		var store = [
          ['Narellan', -34.041380, 150.736294]
        ];
      	var mapNarellan = new google.maps.Map(document.getElementById('mapNarellan'), {
        	zoom: 14,
          	scrollwheel: true,
        	center: {lat: store[0][1], lng: store[0][2]}
    	});
        var markersNarellan = new google.maps.Marker({
    		position: {lat: store[0][1], lng: store[0][2]},
    		map: mapNarellan,
    		title: store[0][0],    
    	}); 
  	}
  
  	var casula = document.getElementById('mapCasula');
  	if (casula) { 
		var store = [
          ['Casula', -33.955479, 150.892045]
        ];
      	var mapCasula = new google.maps.Map(document.getElementById('mapCasula'), {
        	zoom: 14,
          	scrollwheel: true,          
        	center: {lat: store[0][1], lng: store[0][2]}
    	});
        var markersCasula = new google.maps.Marker({
    		position: {lat: store[0][1], lng: store[0][2]},
    		map: mapCasula,
    		title: store[0][0],    
    	}); 
  	}
    
  	var topRyde2 = document.getElementById('mapTopRyde2');
  	if (topRyde2) { 
		var store = [
          ['Top Ryde', -33.812865, 151.106836]
        ];
      	var mapTopRyde2 = new google.maps.Map(document.getElementById('mapTopRyde2'), {
        	zoom: 14,
          	scrollwheel: true,          
        	center: {lat: store[0][1], lng: store[0][2]}
    	});
        var markersTopRyde2 = new google.maps.Marker({
    		position: {lat: store[0][1], lng: store[0][2]},
    		map: mapTopRyde2,
    		title: store[0][0],    
    	}); 
  	}
   
   	var figtree = document.getElementById('mapFigtree');
  	if (figtree) { 
		var store = [
          ['Figtree', -34.436450, 150.863030]
        ];
      	var mapFigtree = new google.maps.Map(document.getElementById('mapFigtree'), {
        	zoom: 14,
          	scrollwheel: true,          
        	center: {lat: store[0][1], lng: store[0][2]}
    	});
        var markersFigtree = new google.maps.Marker({
    		position: {lat: store[0][1], lng: store[0][2]},
    		map: mapFigtree,
    		title: store[0][0],    
    	}); 
  	} 
  
   	var rundlemall = document.getElementById('mapRundleMall');
  	if (rundlemall) { 
		var store = [
          ['Rundle Mall', -34.9228396, 138.5997243]
        ];
      	var mapRundleMall = new google.maps.Map(document.getElementById('mapRundleMall'), {
        	zoom: 14,
          	scrollwheel: true,          
        	center: {lat: store[0][1], lng: store[0][2]}
    	});
        var markersRundleMall = new google.maps.Marker({
    		position: {lat: store[0][1], lng: store[0][2]},
    		map: mapRundleMall,
    		title: store[0][0],    
    	}); 
  	} 
  
    var cronulla = document.getElementById('mapCronulla');
  	if (cronulla) { 
		var store = [
          ['Cronulla', -34.0536761, 151.1520854]
        ];
      	var mapCronulla = new google.maps.Map(document.getElementById('mapCronulla'), {
        	zoom: 14,
          	scrollwheel: true,          
        	center: {lat: store[0][1], lng: store[0][2]}
    	});
        var markersCronulla = new google.maps.Marker({
    		position: {lat: store[0][1], lng: store[0][2]},
    		map: mapCronulla,
    		title: store[0][0],    
    	}); 
  	} 
  
    var docklands = document.getElementById('mapDocklands');
  	if (docklands) { 
		var store = [
          ['Docklands', -37.8145412, 144.9411002]
        ];
      	var mapDocklands = new google.maps.Map(document.getElementById('mapDocklands'), {
        	zoom: 14,
          	scrollwheel: true,          
        	center: {lat: store[0][1], lng: store[0][2]}
    	});
        var markersDocklands = new google.maps.Marker({
    		position: {lat: store[0][1], lng: store[0][2]},
    		map: mapDocklands,
    		title: store[0][0],    
    	}); 
  	} 
  
    var bondi = document.getElementById('mapBondi');
  	if (bondi) { 
		var store = [
          ['Bondi', -33.8939381,151.2597158]
        ];
      	var mapBondi = new google.maps.Map(document.getElementById('mapBondi'), {
        	zoom: 14,
          	scrollwheel: true,          
        	center: {lat: store[0][1], lng: store[0][2]}
    	});
        var markersBondi = new google.maps.Marker({
    		position: {lat: store[0][1], lng: store[0][2]},
    		map: mapBondi,
    		title: store[0][0],    
    	}); 
  	}
  
    var miranda = document.getElementById('mapMiranda');
  	if (miranda) { 
		var store = [
          ['Miranda', -34.0355512,151.1006368]
        ];
      	var mapMiranda = new google.maps.Map(document.getElementById('mapMiranda'), {
        	zoom: 14,
          	scrollwheel: true,          
        	center: {lat: store[0][1], lng: store[0][2]}
    	});
        var markersMiranda = new google.maps.Marker({
    		position: {lat: store[0][1], lng: store[0][2]},
    		map: mapMiranda,
    		title: store[0][0],    
    	}); 
  	}
  
    var paramatta = document.getElementById('mapParramatta');
  	if (paramatta) { 
		var store = [
          ['Parramatta', -33.8179141,150.9995141]
        ];
      	var mapParramatta = new google.maps.Map(document.getElementById('mapParramatta'), {
        	zoom: 14,
          	scrollwheel: true,          
        	center: {lat: store[0][1], lng: store[0][2]}
    	});
        var markersParramatta = new google.maps.Marker({
    		position: {lat: store[0][1], lng: store[0][2]},
    		map: mapParramatta,
    		title: store[0][0],    
    	}); 
  	}
}

// make map scrollable until clicked off
/*google.maps.event.addListener(map, 'mouseout', function(event){
	this.setOptions({scrollwheel:false});  
});

google.maps.event.addListener(map, 'click', function(event){
	this.setOptions({scrollwheel:true});
});*/